import { CollisionDescriptor, CollisionDetection } from '@dnd-kit/core';

// The default collision detection uses distance from the midpoint including
// both horizontal and vertical difference. Since our items may not all be the
// same width if you drag to the right things will get selected out of order.
// This basicaly just choses the closest element using only vertical distance,
// and excludes results that are outside of the droppable element
export const customCollisionDetection: CollisionDetection = ({
  collisionRect,
  droppableContainers,
}) => {
  const verticalCenter = collisionRect.top + collisionRect.height * 0.5;
  const collisions: CollisionDescriptor[] = [];

  droppableContainers.forEach((droppableContainer) => {
    const {
      id,
      rect: { current: rect },
    } = droppableContainer;

    if (rect) {
      const verticalRectCenter = rect.top + rect.height * 0.5;
      const distBetween = Math.abs(verticalCenter - verticalRectCenter);

      const rectHeight = rect.bottom - rect.top;

      collisions.push({
        id,
        data: { droppableContainer, value: distBetween / rectHeight },
      });
    }
  });

  return collisions
    .filter((a) => a.data.value < 1)
    .sort((a, b) => a.data.value - b.data.value);
};
